module.exports = __webpack_public_path__ + "img/elementwidths_jas.40d6f518.png";